import utils from '@/mixins/utils'

export function filtro(equipes, exibirVermelhos, exibirVerdes) {
  let equipesFiltradas = equipes

  if (exibirVermelhos === true) {
  }

  if (exibirVerdes === true) {
  }

  return equipesFiltradas
}
